import React from "react";
import "./tituloModulo.css";

export default function TituloModulo({ titulo }) {
  return (
    <div className="titulo-modulo">
      <h2>{titulo}</h2>
    </div>
  );
}
